// One polite live region for the whole app (#rv-live in index.html). Screen readers only notice
// text that changes inside a region that already exists, so toasts send their words here instead
// of creating a new role="status" node each time.
let timer = 0;
export function announce(text) {
	const el = document.getElementById("rv-live");
	if (!el || !text) return;
	el.textContent = "";
	clearTimeout(timer);
	timer = setTimeout(() => { el.textContent = text; }, 60);
}
